import { useEffect, useState } from 'react';
import TypingCanvas from './typing-canvas';

// `app/24/CodeTyper.js` — the hero background. Picks one of the two bundled source files
// at random on mount, so the rain is different on every load (here and over there alike).
//
// The codes module is ~80 kB and this is the only page that wants it. Next got that for
// free from route-level splitting; here every page component is glob-imported eagerly
// (entrypoints/inertia.ts), so the import is deferred by hand to keep it in its own chunk.
export default function CodeTyper() {
  const [code, setCode] = useState('');

  useEffect(() => {
    let cancelled = false;

    import('../codes').then(({ codes }) => {
      if (cancelled) return;
      const randomCode = codes[Math.floor(Math.random() * codes.length)];
      setCode(randomCode.code.replace(/\s+/g, ' ').trim());
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="relative h-full">
      <pre className="smooth-scroll top-0 left-0 z-10 h-full overflow-y-auto whitespace-pre-wrap bg-transparent text-zinc-800 mix-blend-plus-lighter">
        <TypingCanvas code={code} speed={0.3} />
      </pre>
      <div className="pointer-events-none absolute right-0 bottom-0 left-0 h-[15%] bg-gradient-to-t from-zinc-950 to-transparent" />
    </div>
  );
}
